import "leaflet-rotatedmarker"

import DriftMarker from "leaflet-drift-marker"
import { LeafletProvider, MapLayer, withLeaflet } from "react-leaflet"

const MARKER_SLIDE_DURATION_IN_MS = 5000

class RotatedMarker extends MapLayer {
  static defaultProps = {
    rotationOrigin: "center",
  }

  createLeafletElement(props) {
    const el = new DriftMarker(props.position, this.getOptions(props))
    this.contextValue = { ...props.leaflet, popupContainer: el }
    return el
  }

  updateLeafletElement(fromProps, toProps) {
    if (toProps.position !== fromProps.position) {
      if (document.visibilityState === "visible") {
        this.leafletElement.slideTo(toProps.position, { duration: MARKER_SLIDE_DURATION_IN_MS })
      } else {
        this.leafletElement.setLatLng(toProps.position)
      }
    }
    if (toProps.icon !== fromProps.icon) {
      this.leafletElement.setIcon(toProps.icon)
    }
    if (toProps.zIndexOffset !== fromProps.zIndexOffset) {
      this.leafletElement.setZIndexOffset(toProps.zIndexOffset)
    }
    if (toProps.opacity !== fromProps.opacity) {
      this.leafletElement.setOpacity(toProps.opacity)
    }
    if (toProps.draggable !== fromProps.draggable) {
      if (toProps.draggable === true) {
        this.leafletElement.dragging.enable()
      } else {
        this.leafletElement.dragging.disable()
      }
    }
    if (toProps.rotationAngle !== fromProps.rotationAngle) {
      this.leafletElement.setRotationAngle(toProps.rotationAngle)
    }
    if (toProps.rotationOrigin !== fromProps.rotationOrigin) {
      this.leafletElement.setRotationOrigin(toProps.rotationOrigin)
    }
  }

  render() {
    const { children } = this.props
    return children == null || this.contextValue == null ? null : (
      <LeafletProvider value={this.contextValue}>{children}</LeafletProvider>
    )
  }
}

export default withLeaflet(RotatedMarker)
